import React, { useState, forwardRef } from "react";
import DatePicker from "react-datepicker";

/**
 * Wrapper component for widgets.
 */
export function ChartContainer({ title, subtitle, buttons, collapsable = true, datePicker = false, noHeader = false, children: chart, height, className = '' }) {

    const [collapsed, setCollapsed] = useState(false);
    const [selectedStartDate, setSelectedStartDate] = useState(new Date());
    const [selectedEndDate, setSelectedEndDate] = useState(new Date());

    //DevTeam Sept 07, 2022
    //Added to enable custom data picker for the charts
    const StartDatePickerInput = forwardRef(({ value, onClick }, ref) => (
        <>
            <label className="oct_card-sup-title">Start Date:</label>
            <button className="btn oct_btndate-form" onClick={onClick} ref={ref}>
                {value}
            </button>
        </>
    ));

    //DevTeam Sept 07, 2022
    //Added to enable custom data picker for the charts
    const EndDatePickerInput = forwardRef(({ value, onClick }, ref) => (
        <>
            <label className="oct_card-sup-title">End Date:</label>
            <button className="btn oct_btndate-form" onClick={onClick} ref={ref}>
                {value}
            </button>
        </>
    ));

    return (
        <div className={`card oct_chart-card ${collapsed ? 'collapsed-card' : ''} ${className}`}>
            {!noHeader && (
                <div className="card-header d-flex w-100 align-items-center justify-content-between">
                    <div>
                        {subtitle && <div className="oct_card-sup-title mb-1">{subtitle}</div>}
                        <h3 className="card-title m-0">{title}</h3>
                    </div>

                    <div className="d-flex align-items-center ml-auto">
                        {buttons && buttons.map((button, index) =>
                            <button key={index}
                                className={button.className || "oct_card-btn btn oct_btn-primary"}
                                onClick={button.onClick}>{button.label}</button>)}

                        {collapsable &&
                            <button type="button"
                                className="btn btn-tool oct_btn-collapse"
                                onClick={() => setCollapsed(!collapsed)}>
                                <i className={`fas ${collapsed ? 'fa-plus' : 'fa-minus'}`} />
                            </button>
                        }
                    </div>

                    {datePicker && (
                        <div className="d-flex align-items-center ml-2">
                            <DatePicker
                                selected={selectedStartDate}
                                onChange={(date) => setSelectedStartDate(date)}
                                maxDate={new Date()}
                                customInput={<StartDatePickerInput />}
                            />
                            <DatePicker
                                selected={selectedEndDate}
                                onChange={(date) => setSelectedEndDate(date)}
                                maxDate={new Date()}
                                customInput={<EndDatePickerInput />}
                            />
                        </div>
                    )}

                </div>
            )}
            <div className="card-body">
                {height ? (
                    <div className={`chart oct_height-${height}`}>
                        {chart}
                    </div>
                ) : (
                    chart
                )}
            </div>
        </div>
    )

}
